/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Table from '../../components/common/Table';
import axios from 'axios';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/common/Loading';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const DesktopOnly = styled.div`
  width: 100%;
  @media (max-width: 768px) { display: none; }
`;

const MobileMenuBtn = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: #1c1c1e;
    border-radius: 10px;
    color: #f5f5f7;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow: scroll;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 24px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    height: 100vh;
    margin: 0;
    border-radius: 0;
    padding: 16px;
  }
`;

const Toolbar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 12px;
`;

const SearchInput = styled.input`
  padding: 7px 14px;
  border: 1.5px solid #d2d2d7;
  border-radius: 8px;
  font-size: 14px;
  width: 260px;
  outline: none;
  font-family: inherit;
  transition: border-color 0.15s;
  &:focus { border-color: #007aff; }
`;

const Btn = styled.button`
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  outline: none;
  background: ${({ $primary }) => $primary ? '#007aff' : '#f3f4f6'};
  color: ${({ $primary }) => $primary ? '#fff' : '#374151'};
  &:hover {
    background: ${({ $primary }) => $primary ? '#0066d6' : '#e5e7eb'};
  }
`;

const TotalText = styled.span`
  font-size: 14px;
  color: #86868b;
  font-weight: 500;
`;

const ImgOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const ImgPreview = styled.img`
  max-width: 80vw;
  max-height: 80vh;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.3);
  object-fit: contain;
  background: #fff;
`;

const ProductListPage = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState();
  const [allProducts, setAllProducts] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [previewImg, setPreviewImg] = useState(null);

  const getProducts = async () => {
    try {
      setIsLoading(true);
      let { data: res } = await axios.get('/admin/products/productlist');
      setAllProducts(res);
      applyFilter(res, '');
      setIsLoading(false);
    } catch (e) {
      console.log(e, 'getList');
      setIsLoading(false);
    }
  };

  const applyFilter = (data, query) => {
    let filtered = data;
    if (query) {
      const q = query.toLowerCase();
      filtered = data.filter((r) =>
        (r.product_name || '').toLowerCase().includes(q) ||
        (r.main_category || '').toLowerCase().includes(q) ||
        (r.sub_category || '').toLowerCase().includes(q)
      );
    }
    const ids = filtered.map((r) => r._id);
    const rows = filtered.map((r) => ({
      img: r.img ? <img src={r.img} alt="" onClick={(e) => { e.stopPropagation(); setPreviewImg(r.img); }} style={{ width: 56, height: 56, borderRadius: 10, objectFit: 'cover', background: '#f5f5f7', border: '1px solid #e5e7eb', cursor: 'zoom-in' }} /> : <div style={{ width: 56, height: 56, borderRadius: 10, background: '#f5f5f7', border: '1px solid #e5e7eb' }} />,
      main_category: r.main_category,
      sub_category: r.sub_category,
      product_name: r.product_name,
      order_count: r.order_count || 0,
    }));
    setProductIds(ids);
    setProducts(rows);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    applyFilter(allProducts, searchInput);
  };

  const handleReset = () => {
    setSearchInput('');
    applyFilter(allProducts, '');
  };

  const handleRowClick = (index) => {
    if (productIds[index]) {
      navigate(`/product/list/detail/${productIds[index]}`);
    }
  };

  const titles = ['', '제조사', '카테고리', '제품명', '주문'];

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <Container>
      <div style={{ width: '100%', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 10 }}>
        <MobileMenuBtn onClick={() => window.dispatchEvent(new Event('open-sidebar'))}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </MobileMenuBtn>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0 }}>제품 조회</h2>
      </div>
      <DesktopOnly>
      <Toolbar>
        <div style={{ display: 'flex', gap: 6 }}>
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: 6 }}>
            <SearchInput
              placeholder="제품명, 제조사, 카테고리 검색"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <Btn $primary type="submit">검색</Btn>
          </form>
          {searchInput && <Btn onClick={handleReset}>초기화</Btn>}
        </div>
        <TotalText>총 {products ? products.length : 0}개</TotalText>
      </Toolbar>
      </DesktopOnly>
      {products && products.length > 0 ? (
        <Table
          titles={titles}
          data={products}
          onRowClick={handleRowClick}
        />
      ) : !isLoading && (
        <div style={{ color: '#86868b', fontSize: 15, padding: '80px 0', textAlign: 'center', width: '100%' }}>
          {searchInput ? '검색 결과가 없습니다.' : '제품이 없습니다.'}
        </div>
      )}
      {isLoading && <Loading />}
      {previewImg && (
        <ImgOverlay onClick={() => setPreviewImg(null)}>
          <ImgPreview src={previewImg} onClick={(e) => e.stopPropagation()} />
        </ImgOverlay>
      )}
    </Container>
  );
};

export default ProductListPage;
